/* eslint-disable import/no-anonymous-default-export */
export default {
  logout: "Logout",
  logoutAlert: "Are you sure you want to log out?",
};
